export type SessionStatusKey =
  | "confirmed"
  | "awaiting"
  | "needs-payment"
  | "closed"
  | "pending-change"
  | "cancelled"
  | "unknown";

export type StatusTone = "sage" | "spark" | "rust" | "ink-4" | "ink-5";

export interface SessionStatusInfo {
  key: SessionStatusKey;
  label: string;
  tone: StatusTone;
}

const AWAITING_STATES = new Set([
  "auth_completed",
  "signed_fee_agreement",
  "processing",
  "fee_ag_generated",
  "admin_email_sent",
  "cust_email_sent",
  "fee_email_sent",
]);

export function bookingStateToStatus(state: string): SessionStatusInfo {
  if (state === "sent_invite") {
    return { key: "confirmed", label: "Confirmed", tone: "sage" };
  }
  if (AWAITING_STATES.has(state)) {
    return { key: "awaiting", label: "Awaiting", tone: "spark" };
  }
  if (state === "pending_auth") {
    return { key: "needs-payment", label: "Needs payment", tone: "rust" };
  }
  if (state === "closed") {
    return { key: "closed", label: "Closed", tone: "ink-4" };
  }
  if (state === "to_cancel") {
    return { key: "cancelled", label: "Cancelling", tone: "rust" };
  }
  if (state === "cancelled") {
    return { key: "cancelled", label: "Cancelled", tone: "ink-5" };
  }
  if (state === "to_move") {
    return { key: "pending-change", label: "Pending move", tone: "ink-5" };
  }
  // Fallback: capitalize
  const label = state
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
  return { key: "unknown", label, tone: "ink-5" };
}

/** States where cancellation is allowed */
export const CANCELLABLE_STATES = new Set([
  "pending_auth",
  "auth_completed",
  "processing",
  "fee_ag_generated",
  "admin_email_sent",
  "cust_email_sent",
  "fee_email_sent",
  "sent_invite",
  "signed_fee_agreement",
]);

/** States where move is allowed */
export const MOVABLE_STATES = new Set(["sent_invite", "auth_completed"]);

/** States where close is NOT allowed */
export const NON_CLOSABLE_STATES = new Set([
  "closed",
  "to_cancel",
  "to_move",
  "cancelled",
]);
